module.exports = __webpack_public_path__ + "static/img/C4D0023.c09f4e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0023.jpg
// module id = raek
// module chunks = 0